import lodashPick from 'lodash-es/pick';

export const enumPick = <T extends Record<string, unknown>, K extends keyof T>(enumObj: T, keys: readonly K[]): Pick<T, K> =>
    lodashPick(enumObj, keys) as Pick<T, K>;
